import { createFeatureSelector } from '@ngrx/store';
import { STORYBLOK_FEATURE_NAME } from './feature-name';

export const getStoryblokState = createFeatureSelector(STORYBLOK_FEATURE_NAME);
